import { ChangeEvent } from 'react';
import PhoneInput from 'react-phone-number-input/mobile';
import 'react-phone-number-input/style.css';
import { capitalizeFirstLetter } from '../../../../utils/utilsFunctions';
import { InputField } from '../../../common/InputField/InputField';
import { ErrorInputText } from '../../../styledComponent/SignUpComponents.style';
import { SignUpBottomTextInput } from '../../../styledComponent/Text.style';
import { InputFieldProps, SignUpFields, SignUpValues } from '../../SignUp/SignUp.types';
import { ThinLabel } from '../SignupWithPayment.style';
import { SignupFormInputRoot, SignupFormWrapper } from './SignupForm.style';
import { TEXT_INPUT_MAX_LENGTH, PHONE_INPUT_MAX_LENGTH } from '../../../common/InputField/InputField.const';

interface SignumFormProps {
  inputFields: InputFieldProps[];
  signUpValues: SignUpValues;
  signUpInputError: SignUpValues;
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  phoneChange: (value: string | undefined) => void;
  areInputsDisabled: boolean;
}

export const SignupForm: React.FC<SignumFormProps> = ({
  inputFields,
  handleChange,
  phoneChange,
  signUpValues,
  signUpInputError,
  areInputsDisabled,
}) => {
  const idStart = 'signUpForm';

  return (
    <SignupFormWrapper>
      <ThinLabel>Contact details</ThinLabel>
      {inputFields.map((inputField, index) => (
        <SignupFormInputRoot key={`${inputField.type}-${index}`}>
          {inputField.type !== SignUpFields.Phone ? (
            <InputField
              id={`${idStart}${capitalizeFirstLetter(inputField.type)}`}
              type={inputField.type === SignUpFields.Name ? 'text' : 'email'}
              error={signUpInputError[inputField.type]}
              name={inputField.type}
              maxLength={TEXT_INPUT_MAX_LENGTH}
              handleChange={(event: ChangeEvent<HTMLInputElement>) => handleChange(event)}
              value={signUpValues[inputField.type]}
              placeholder={inputField.placeHolder}
              bottomText={inputField.explanation ? inputField.explanation : ''}
              disabled={areInputsDisabled}
            />
          ) : (
            <>
              <PhoneInput
                id={`${idStart}${capitalizeFirstLetter(inputField.type)}`}
                onChange={(value: string | undefined) => phoneChange(value)}
                value={signUpValues[SignUpFields.Phone]}
                placeholder={inputField.placeHolder}
                defaultCountry={'US'}
                maxLength={PHONE_INPUT_MAX_LENGTH}
                disabled={areInputsDisabled}
                className={signUpInputError[inputField.type] ? 'error' : ''}
              />
              {inputField.explanation && signUpInputError[inputField.type].length === 0 ? (
                <SignUpBottomTextInput>{inputField.explanation}</SignUpBottomTextInput>
              ) : (
                ''
              )}
            </>
          )}
          {signUpInputError[inputField.type].length > 0 ? (
            <ErrorInputText>{signUpInputError[inputField.type]}</ErrorInputText>
          ) : (
            ''
          )}
        </SignupFormInputRoot>
      ))}
    </SignupFormWrapper>
  );
};
